export const colors = {
    white: '#fff',
    red: '#ff0000',
    yellow: '#ffff00',
    green: '#00ff00',
    blue: '#0000ff',
    orange: '#ff7700',
    icon: 'rgb(235, 232, 232)',
    disabledIcon: 'rgb(128, 128, 128)',
    iconWSGI: 'rgb(235, 0, 0)',
    disabledIconWSGI: 'rgb(128, 0, 0)',
    barBackground: 'rgba(15, 15, 15, 0.68)',
    barBackgroundDark: 'rgba(15, 15, 15, 0.88)',
    lightBlue: '#0066ff',
    black: '#000',
    correctInput: 'rgba(0, 255, 0, 1)',
    incorrectInput: 'rgba(255, 0, 0, 1)',
    trasparent: 'rgba(0, 0, 0, 0)',
    grey: 'rgba(128, 128, 128, 1)',
    lightGrey: 'rgba(192,192,192,1)',
}

export const OLFontsAndColors = {
    textFont: 'bold 16px serif',
    white: '#ffffff',
    blue: '#0000ff',
    black: '#000000',
    transparent: 'rgba(210,210,210,1)'
}

export const layerColors = {
    textFont: 'bold 16px serif',
    textFill: 'rgb(255, 255, 255)',
    textContour: 'rgb(0, 0, 0)',
    point: 'rgb(0, 0, 255)',
    curve: 'rgb(0, 0, 255)',
    curveKml: 'rgb(255, 0, 0)',
    fill: 'rgb(210, 210, 210)'
}

/**
 * That function remove alpha information from css rgba and convert it to css rgb
 * @param {String} rgba - css rgba format
 * @returns {String} - css rgb format
 */
export const convertRgbaToRgb = (rgba) => {
    try{
        const rgbaSplit = rgba.split("(")[1].split(")")[0].split(",");;
        const r = parseInt(rgbaSplit[0]);
        const g = parseInt(rgbaSplit[1]);
        const b = parseInt(rgbaSplit[2]);
        return `rgb(${r},${g},${b})`;
    }catch(e){
        console.log("failed convert rgba to rgb", e);
        return 'rgb(0,0,0)';
    }
}